export const displayNewTopicList = (topics) => {
    return {
        type : "SHOW",
        payload : topics
    }
}